import { gql } from "lib/apolloClient";
import { organizationFragments } from "./InternalToolsFragment";

export const getOrganizationGradesQuery = gql`
  query getOrganizationGrades(
    $organizationId: ID!
    $gradeFilters: GradeFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        grades(filters: $gradeFilters) {
          id
          name
        }
      }
    }
  }
`;

export const getOrganizationCoursesQuery = gql`
  query getOrganizationCourses(
    $organizationId: ID!
    $courseFilters: CourseFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        courses(
          orderBy: TITLE
          orderByDirection: ASC
          filters: $courseFilters
        ) {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
`;

export const getOrganizationFeedQuery = gql`
  query getOrganizationFeed($filters: OrganizationFeedConnectionFilter) {
    platform {
      organizationFeed(first: 1, filters: $filters) {
        totalCount
        edges {
          node {
            ...organizationFeedDetailsItem
            __typename
          }
        }
      }
      __typename
    }
  }
  ${organizationFragments.organizationFeedDetailsItem}
`;

export const getInternalToolGenericDataQuery = gql`
  query getInternalToolGenericData($input: InternalToolsGenericApiInput!) {
    platform {
      internalToolsGenericQuery(input: $input) {
        isSuccess
        data
        warning
      }
    }
  }
`;

export const getOrganizationGlobalConstantsQuery = gql`
  query getOrganizationGlobalConstants(
    $organizationId: ID!
    $filter: GlobalConstantsFilterOptions
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      ... on Organization {
        id
        globalConstants(filter: $filter) {
          ...organizationGlobalConstantItem
        }
      }
    }
  }
  ${organizationFragments.organizationGlobalConstants}
`;

export const getJobStatusQuery = gql`
  query getJobStatus($id: ID!) {
    node(id: $id, type: INTEGRATION_JOB) {
      id
      ... on IntegrationJob {
        status
      }
    }
  }
`;

export const getDownloadTemplateFileQuery = gql`
  query getDownloadTemplateFile(
    $organizationId: ID!
    $type: String!
    $subType: String!
    $curriculumProgramId: ID
    $academicYearId: ID
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        name
        organizationDataBulkDownload(
          type: $type
          subType: $subType
          curriculumProgramId: $curriculumProgramId
          academicYearId: $academicYearId
        )
      }
    }
  }
`;

export const getToddleBuddiesQuery = gql`
  query getToddleBuddies {
    platform {
      buddies {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const getFoundationsQuery = gql`
  query getFoundations($filters: AcademyFilters) {
    platform {
      academy(filters: $filters) {
        foundations {
          name
          id
          curriculum
          workrampFoundationId
          tags
        }
      }
    }
  }
`;

export const getTrainingsQuery = gql`
  query getTrainings($filters: AcademyFilters) {
    platform {
      academy(filters: $filters) {
        foundations {
          id
          trainings {
            id
            name
            workrampTrainingId
          }
        }
      }
    }
  }
`;

export const getOrganizationLearningCoursesQuery = gql`
  query getOrganizationLearningCourses(
    $organizationId: ID!
    $first: Int
    $after: String
    $filters: LearningCourseFilters
    $orderBy: OrderByEnum
    $orderByDirection: OrderByDirectionEnum
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        learningCourses(
          first: $first
          after: $after
          filters: $filters
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          edges {
            node {
              id
              title
              state
              __typename
            }
            __typename
          }
          pageInfo {
            hasNextPage
            endCursor
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const getOrganizationUnitPlanFeedQuery = gql`
  query getOrganizationUnitPlanFeed(
    $id: ID!
    $filters: UnitPlansV2FeedFilters!
    $after: String
    $first: Int
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        unitPlans: unitPlansV2(
          first: $first
          after: $after
          filters: $filters
        ) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
            __typename
          }
          edges {
            node {
              id
              state
              startDate
              endDate
              title {
                id
                value
                __typename
              }
              unitCode {
                id
                value
                __typename
              }
              courses {
                id
                title
                __typename
              }
              curriculumProgram {
                id
                type
                label
                acronym
                __typename
              }
              createdBy {
                id
                firstName
                lastName
                __typename
              }
              owner {
                id
                firstName
                lastName
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const removeSuppressedEmailQuery = gql`
  query removeSuppressedEmail($input: RemoveSuppressedEmailInput!) {
    platform {
      removeSuppressedEmail(input: $input) {
        totalCount
        passedCount
        failedCount
        results {
          email
          success
          response
          error
        }
      }
    }
  }
`;
